import React from 'react';
import { List } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

class NavSetupContainer extends React.Component {
  getClassName(path) {
    return path === this.props.location.pathname ? 'item active' : 'item';
  }

  //TODO: make reusable component

  render() {
    return (
      <List link>
        <List.Item>
          <List.Content className="group-header">User</List.Content>
          <List link>
            <Link
              to="/userroles"
              className={this.getClassName('/userroles')}
              role="listitem"
            >
              Role Setup
            </Link>
            <Link
              to="/usersetup"
              className={this.getClassName('/usersetup')}
              role="listitem"
            >
              User Setup
            </Link>
          </List>
        </List.Item>
        <List.Item>
          <List.Content className="group-header">Site</List.Content>
          <List link>
            <Link
              to="/sitegroup"
              className={this.getClassName('/sitegroup')}
              role="listitem"
            >
              Site Group
            </Link>
            <Link
              to="/importsite"
              className={this.getClassName('/importsite')}
              role="listitem"
            >
              Import Sites
            </Link>
            <Link
              to="/sitesetup"
              className={this.getClassName('/sitesetup')}
              role="listitem"
            >
              Site Setup
            </Link>
          </List>
        </List.Item>
        <List.Item>
          <List.Content className="group-header">License</List.Content>
          <List link>
            <Link
              to="/license"
              className={this.getClassName('/license')}
              role="listitem"
            >
              Import
            </Link>
            <Link
              to="/assignlicense"
              className={this.getClassName('/assignlicense')}
              role="listitem"
            >
              Assign Sites
            </Link>
          </List>
        </List.Item>
        <List.Item>
          <List.Content className="group-header">STUDENTS</List.Content>
          <List link>
            <Link
              to="/importstudents"
              className={this.getClassName('/importstudents')}
              role="listitem"
            >
              Import
            </Link>
          </List>
        </List.Item>
      </List>
    );
  }
}
//TODO: Fix...not good to do this.  could break on dynamic routing
const mapStateToProps = ({ routing }) => {
  return {
    location: routing.location,
  };
};

export const NavSetup = connect(mapStateToProps, null)(NavSetupContainer);



// WEBPACK FOOTER //
// ./src/components/app/sidebar/NavSetup.js